import {
  ISetProjectCountsParams,
  ManagementLayoutActionTypes,
  SET_MANAGEMENT_LEFT_PANEL_COLLAPSED,
  SET_PROJECT_COUNTS
} from "./types";

export const setManagementLeftPanelCollapsed = (isLeftPanelCollapsed: boolean): ManagementLayoutActionTypes => {
  return {
    type: SET_MANAGEMENT_LEFT_PANEL_COLLAPSED,
    meta: {
      params: {
        isLeftPanelCollapsed
      }
    }
  };
};

export const setProjectCounts = (params: ISetProjectCountsParams): ManagementLayoutActionTypes => {
  return {
    type: SET_PROJECT_COUNTS,
    meta: {
      params
    }
  };
};
